import { Box } from "@braintrust/braintrust-ui-components";

import { Sanitize } from "../sanitize";

import styles from "./styles.module.scss";

type MarkdownContentProps = { markdown: string };

export const MarkdownContent = ({ markdown }: MarkdownContentProps) => {
  return (
    <Box className={styles.markdownContent}>
      <Sanitize input={markdown} keepOriginalStyles />
    </Box>
  );
};
